import * as React from 'react';
import styled from 'styled-components';

import { CollectionListItem } from 'base/api/types';
import { Row, Title } from 'common/components';
import ContentRow, { ContentRowProps } from 'templates/content/components/ContentRow';

const CollectionRow = (props: ContentRowProps<CollectionListItem>) => {
  const { index, data } = props;
  const { title } = data[index];

  return (
    <StyledContentRow {...props}>
      <TitleCell>
        <Row>
          <Title size="standard">{title}</Title>
        </Row>
      </TitleCell>
    </StyledContentRow>
  );
};

const StyledContentRow = styled(ContentRow)`
  justify-content: space-between;
`;

const TitleCell = styled.div`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: ${({ theme }) => theme.spacer.times(3)};
`;

export default CollectionRow;
